var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M29 7.417L26.583 5 17 14.583 7.417 5 5 7.417 14.583 17 5 26.583 7.417 29 17 19.417 26.583 29 29 26.583 19.417 17z","transform":"translate(-5 -5)"}));
}

IconClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconClose;

IconClose.default = IconClose;
